import { isElementScrollable } from '../../scroll';
import { platform } from '../../platform';

/**
 * garantir que regiões com rolagem sejam acessadas por teclado
 * https://dequeuniversity.com/rules/axe/3.5/scrollable-region-focusable
 *
 * @param element elemento a ser verificado
 *
 * @category A11y
 */
export const ensureScrollableAccess = (element: HTMLElement): void => {
  if (platform.isMobile || !element) {
    return;
  }

  if (!isElementScrollable(element)) {
    element.removeAttribute('tabindex');

    return;
  }

  element.setAttribute('tabindex', '0');
};
